module.exports = __webpack_public_path__ + "static/media/Chiller_plant-5.d4f13be4.png";